import { render, staticRenderFns } from "./UserShipDetails.html?vue&type=template&id=0de12c18&scoped=true&"
import script from "./UserShipDetails.ts?vue&type=script&lang=ts&"
export * from "./UserShipDetails.ts?vue&type=script&lang=ts&"
import style0 from "./UserShipDetails.css?vue&type=style&index=0&id=0de12c18&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0de12c18",
  null
  
)

export default component.exports